export default {
	title: "Web3",
	rule: "Regelbeskrivelse",
	safe: "Pengesikkerhet",
	balance: {
		total: "Totalbeløp",
		yesterday: "Gevinst i går",
		cumulatively: "Kumulativ gevinst",
		in: "Innbetalt beløp",
		out: "Utbetalt beløp",
		available: "Tilgjengelig saldo"
	},
	actions: {
		in: "Innbetaling",
		out: "Utbetaling"
	},
	type: ["Alle", "Innbetaling", "Utbetaling", "Gevinst"],
	TransactionPassword: "Transaksjonspassord",
	Amount: "Beløp",
	date: "Dato"
};
